import Handlebars from 'handlebars';
      const _template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-test-label-self-serve-engaged class=\"ml-4\">\n  <div class=\"font-normal\">Tried to resolve</div>\n  <div class=\"font-normal\">with self-serve content</div>\n</div>\n";
},"useData":true});
      export default _template;